import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import Guarantees from "@/pages/guarantees/page";
import Team from "@/pages/team/page";
import Reviews from "@/pages/reviews/page";
import Pricing from "@/pages/pricing/page";
import Cases from "@/pages/cases/page";
import Results from "@/pages/results/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/guarantees", element: <Guarantees /> },
  { path: "/team", element: <Team /> },
  { path: "/reviews", element: <Reviews /> },
  { path: "/cases", element: <Cases /> },
  { path: "/results", element: <Results /> },
  { path: "/pricing", element: <Pricing /> },
  { path: "*", element: <NotFound /> },
];

export default routes;